enum ArticleImageType {
  banner = 1,
  detail = 2,
}

export default ArticleImageType;
